"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlashingCellStyle = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const rebass_1 = require("rebass");
const StylePreview_1 = require("../../components/StylePreview");
const FlashingCellStyle = (props) => {
    const { data } = props, boxProps = tslib_1.__rest(props, ["data"]);
    return (react_1.default.createElement(rebass_1.Flex, Object.assign({ flexDirection: "row" }, boxProps),
        react_1.default.createElement(StylePreview_1.StylePreview, { "data-value": "up-style", mr: 1, flex: 1, styleObject: props.data.UpChangeStyle },
            "Up ",
            !props.data.UpChangeStyle ? ' - no style' : ''),
        react_1.default.createElement(StylePreview_1.StylePreview, { "data-value": "down-style", mr: 1, flex: 1, styleObject: props.data.DownChangeStyle },
            "Down",
            !props.data.DownChangeStyle ? ' - no style' : ''),
        react_1.default.createElement(StylePreview_1.StylePreview, { "data-value": "neutral-style", flex: 1, styleObject: props.data.NeutralChangeStyle },
            "Neutral ",
            !props.data.NeutralChangeStyle ? ' - no style' : '')));
};
exports.FlashingCellStyle = FlashingCellStyle;
